/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: https://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  updateParticipation({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/update_participation_candidat_formation/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          /*let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)*/
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addParticipation({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_participation_candidat_formation", item)
        .then((response) => {
          //commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  delletParticipation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/destroyParticipation_candidat_formation/${userId}`)
        .then((response) => {
          //commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addParticipationCandidat({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/add_participation_and_candidat_formation", item)
        .then((response) => {
          //commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/add_Candidat", item)
         .then((response) => {
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getCandidat")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getCandidat_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser_inscrie(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_participations_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClasses({ commit},userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classes_candidat_id/${userId}`)
        .then((response) => {
          commit('SET_CLASSES', response.data)
          console.log('a',response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSeance({ commit},userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classes_candidat_id/${userId}`)
        .then((response) => {
          commit('SET_SEANCE', response.data)
          
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyCandidat/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateCandidat/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateavatarRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateCandidatavatar/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAdmins({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getadmins")
        .then((response) => {
          console.log("admins",response.data)
          commit('SET_ADMINS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAdmin({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyAdmin/${userId}`)
        .then((response) => {
          commit('REMOVE_ADMIN', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addAdmin({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("https://trainingcenterback.codily.net/api/addadmin", item)
        .then((response) => {
          commit('ADD_ADMIN', Object.assign(item, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
